export default __webpack_public_path__ + "static/media/safej.cad43305.jpg";